<template>
<div v-if="status.restoringSession || status.loggingIn || redirecting">
	<v-dialog
	v-model="show"
	width="300px"
	hide-overlay
	>
		<v-card
			color="primary"
			dark
		>
			<v-card-text>
			<template v-if="status.restoringSession">
				Restoring session …
			</template>
			<template v-else-if="status.loggingIn">
				Logging in …
			</template>
			<template v-else-if="redirecting">
				Redirecting …
			</template>
			<v-progress-linear
				indeterminate
				color="white"
				class="mb-0"
			></v-progress-linear>
			</v-card-text>
		</v-card>

	</v-dialog>
</div>
<div v-else-if="!status.loggedIn">
	<v-dialog v-model="show" persistent width="800px">
		<v-card>
			<v-card-title class="headline">
				Please login
			</v-card-title>
			<v-container>
				<v-layout row wrap>
					<v-flex xs12>
						<v-alert
						:value="status.error"
						type="error"
						icon="warning"
						>
						{{status.error}}
						</v-alert>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							prepend-icon="fa-user"
							placeholder="User handle or email address"
							v-model="credentials.handle"
						></v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							:append-icon="showPwd ? 'fa-eye-slash' : 'fa-eye'"
							@click:append="showPwd = !showPwd"
							:type="showPwd ? 'text' : 'password'"
							prepend-icon="fa-key"
							placeholder="Password"
							v-model="credentials.password"
						></v-text-field>
					</v-flex>
				</v-layout>
			</v-container>
				<v-card-actions>
					<v-btn flat @click="dismiss">Cancel</v-btn>
					<v-spacer></v-spacer>
					<v-btn flat color="primary" @click="submit" :disabled="!formValid">Login</v-btn>
				</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import Vuex from 'vuex'
import api from '../../assets/js/api-instance'

export default {
	name: "FollowLogin",
	
	props: ["show"],

	data () {
		return {
			credentials: {
				handle: null,
				password: null
			},
			showPwd: false,
			redirecting: false,
			status: {}
		};
	},

	watch: {
		status (newValue, oldValue) {
			if (newValue.restoringSession) {
			} else if (newValue.loggedIn) {
				this.maybeRedirect();
			}
		}
	},

	computed: {
		...Vuex.mapState(["user"]),

		formValid () {
			return this.credentials.handle && this.credentials.password;
		}

	},

	methods: {
		//...Vuex.mapActions([ "login" ]),
		
		async dismiss () {
			this.credentials = {
				handle: null,
				password: null
			};
			this.status = {};
			this.$emit("hide");
		},

		async submit () {
			//await this.login(this.credentials);
			//this.maybeRedirect();
			try {
				await api.login(this.credentials, {errors: { broadcast: false} });
				await this.$store.dispatch('restore');
				this.$emit("hide");
			} catch (err) {
				console.log("Eee", err);
				if (err.unauthorised) {
					this.status = { error: "Bad login" };
				} else if (err.code == "network_error") {
					this.status = { error: "Network error" };
				} else {
					this.status = { error: err.message || "Unknown error" };
				}
			}
			this.credentials = {};
		},

		maybeRedirect () {
			if (this.status.loggedIn) {
				this.redirecting = true;
				if (this.$route.query.redirect) {
					this.$router.replace(this.$route.query.redirect);
				} else {
					this.$router.replace("/");
				}
				this.$emit("hide");
				this.redirecting = false;
			}
		}
	},

	created () {
		this.maybeRedirect();
	}
}
</script>
